<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <v-tabs slider-color="primary">
          <v-tab>{{$t('EmployeeDetails')}}</v-tab>
          <v-tab>ข้อมูลการทำงาน</v-tab>
          <v-tab>รายละเอียดทั่วไป</v-tab>
          <v-tab>ตั้งค่าภาษี</v-tab>
          <!-- ข้อมูลพนักงาน -->
          <v-tab-item>
            <v-card>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex md6 sm6 xs12 align-center justify-center layout text-xs-center>
                    <v-avatar size="256" :tile="true" @click="''">
                      <v-icon size="256" color="black" style="cursor: pointer;">fa-image</v-icon>
                      <img src="''" alt="alt" style="display: none;">
                    </v-avatar>
                  </v-flex>
                  <v-flex md6 sm6 xs12>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                          :label="$t('employee_code')"
                          hide-details
                          append-icon="fas fa-plus-circle"
                          class="pa-1"
                        />
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field name="ชื่อ" label="ชื่อ" hide-details class="pa-1"/>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field name="นามสกุล" label="นามสกุล" hide-details class="pa-1"/>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field label="เบอร์โทรศัพท์" hide-details class="pa-1"/>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-textarea label="ที่อยู่" name="ที่อยู่" hide-details class="pa-1"/>
                  </v-flex>
                  <v-flex md6 sm6 xs12 class="pa-1">
                    <v-text-field name="อีเมลล์" label="อีเมลล์" hide-details class="pa-1"/>
                  </v-flex>
                  <v-flex md6 sm6 xs12 class="pa-1">
                    <v-text-field name="Line ID" label="Line ID" hide-details class="pa-1"/>
                  </v-flex>
                  <v-flex md6 sm6 xs12 class="pa-1">
                    <v-text-field name="วันเกิด" label="วันเกิด" hide-details class="pa-1"/>
                  </v-flex>
                  <v-flex md6 sm6 xs12 class="pa-1">
                    <v-text-field name="สัญชาติ" label="สัญชาติ" hide-details class="pa-1"/>
                  </v-flex>
                  <v-flex md6 sm6 xs12 class="pa-1">
                    <v-text-field
                      name="เลขประจำตัวประชาชน"
                      label="เลขประจำตัวประชาชน"
                      hide-details
                      class="pa-1"
                    />
                  </v-flex>
                  <v-flex md6 sm6 xs12 class="pa-1">
                    <v-text-field name="เชื้อชาติ" label="เชื้อชาติ" hide-details class="pa-1"/>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <!-- ข้อมูลการทำงาน -->
          <v-tab-item>
            <v-card>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-layout row wrap class="mb-2">
                      <v-flex md4 sm4 xs12 class="pa-1">
                        <v-select
                          :items="branch_model"
                          label="สาขา"
                          item-text="ชื่อ"
                          item-value="รหัส"
                          hide-details
                        />
                      </v-flex>
                      <v-flex md4 sm4 xs12 class="pa-1">
                        <v-select
                          :items="group_model"
                          label="ฝ่าย"
                          item-text="ชื่อ"
                          item-value="รหัส"
                          hide-details
                        />
                      </v-flex>
                      <v-flex md4 sm4 xs12 class="pa-1">
                        <v-text-field name="แผนก" label="แผนก" hide-details/>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <h3>ประเภทรายรับ</h3>
                        <v-layout row wrap class="ma-3">
                          <v-flex xs12>
                            <v-radio-group :column="false" class="mt-0">
                              <template v-for="item in salary_type_items">
                                <v-radio :label="item.ชื่อ" :value="item.รหัส" :key="item.รหัส"/>
                              </template>
                            </v-radio-group>
                          </v-flex>
                          <v-flex sm6 xs12 pr-2>
                            <v-text-field name="ฐานเงินเดือน" label="ฐานเงินเดือน" hide-details/>
                          </v-flex>
                          <v-flex sm6 xs12 >
                            <v-text-field
                              readonly
                              hide-details
                              name="เงินเดือนปัจจุบัน"
                              label="เงินเดือนปัจจุบัน"
                              append-outer-icon="search"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <h3>รายการหักเงิน</h3>
                        <v-layout row wrap class="ma-3">
                          <v-flex xs12>
                            <v-checkbox
                              label="ใช้ระบบคำนวนเงินประกันสังคม"
                              value="value"
                              class="mt-0"
                            />
                            <v-checkbox label="ใช้ระบบคำนวนภาษี" value="value" class="mt-0"/>
                          </v-flex>
                          <v-flex md6 sm6 xs12 class="pa-1">
                            <v-text-field label="ประกันสังคม" hide-details/>
                          </v-flex>
                          <v-flex md6 sm6 xs12 class="pa-1">
                            <v-text-field label="ภาษีหัก ณ ที่จ่าย" hide-details/>
                          </v-flex>
                          <v-flex md6 sm6 xs12 class="pa-1">
                            <v-text-field label="วันที่เริ่มทำงาน" hide-details type="date"/>
                          </v-flex>
                          <v-flex md6 sm6 xs12 class="pa-1">
                            <v-text-field label="ฐานชั่วโมงคำนวน" hide-details/>
                          </v-flex>
                          <v-flex xs12 class="mt-2" pa-1>
                            <h4>สถานะ</h4>
                            <v-layout row wrap>
                              <v-flex xs12 px-2>
                                <v-radio-group
                                  v-model="form_model.status"
                                  :column="false"
                                  hide-details
                                  class="mt-0"
                                >
                                  <template>
                                    <v-radio label="ทดลองงาน" value="0"/>
                                    <v-radio label="บรรจุ" value="1"/>
                                    <v-radio label="พนักงาน" value="2"/>
                                  </template>
                                </v-radio-group>
                                
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex xs12>
                            <v-select
                              :items="วันหยุดประจำปี"
                              label="วันหยุดประจำปี"
                              item-text="ชื่อ"
                              item-value="รหัส"
                              hide-details
                            />
                          </v-flex>
                          <v-flex xs12 class="my-3">
                            <v-layout align-center justify-center row fill-height>
                              <v-flex md2 sm2 xs4>
                                <h5>วันหยุดประจำสัปดาห์:</h5>
                              </v-flex>
                              <v-flex md10 sm10 xs8>
                                <v-layout row wrap>
                                  <v-flex md1 sm2 xs3>
                                    <v-checkbox label="จ." value hide-details class="mt-0"/>
                                  </v-flex>
                                  <v-flex md1 sm2 xs3>
                                    <v-checkbox label="อ." value hide-details class="mt-0"/>
                                  </v-flex>
                                  <v-flex md1 sm2 xs3>
                                    <v-checkbox label="พ." value hide-details class="mt-0"/>
                                  </v-flex>
                                  <v-flex md1 sm2 xs3>
                                    <v-checkbox label="พฤ." value hide-details class="mt-0"/>
                                  </v-flex>
                                  <v-flex md1 sm2 xs3>
                                    <v-checkbox label="ศ." value hide-details class="mt-0"/>
                                  </v-flex>
                                  <v-flex md1 sm2 xs3>
                                    <v-checkbox label="ส." value hide-details class="mt-0"/>
                                  </v-flex>
                                  <v-flex md1 sm2 xs3>
                                    <v-checkbox label="อา." value hide-details class="mt-0"/>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex sm6 xs12 px-1>
                            <v-select
                              :items="โปรไฟล์กะการทำงาน"
                              label="กะการทำงาน"
                              item-text="ชื่อ"
                              item-value="รหัส"
                              hide-details
                            />
                          </v-flex>
                          <v-flex sm6 xs12 px-1>
                            <v-select
                              :items="โปรไฟล์กะการทำงาน"
                              label="เงื่อนไขการหักเงิน"
                              item-text="ชื่อ"
                              item-value="รหัส"
                              hide-details
                            />
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <h3>รายได้เสริม</h3>
                        <v-layout row wrap class="ma-3">
                          <v-flex 6 md6 sm xs12 class="pa-1">
                            <v-text-field name="ค่าฝีมือ" label="ค่าฝีมือ" hide-details/>
                          </v-flex>
                          <v-flex 6 md6 sm xs12 class="pa-1">
                            <v-text-field name="ค่าตำแหน่ง" label="ค่าตำแหน่ง" hide-details/>
                          </v-flex>
                          <v-flex 6 md6 sm xs12 class="pa-1">
                            <v-text-field name="พิเศษ" label="พิเศษ" hide-details/>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <h3>ข้อมูลบัญชีรับเงินเดือน</h3>
                        <v-layout row wrap class="ma-3">
                          <v-flex md6 sm xs12 class="pa-1">
                            <v-text-field label="ธนาคาร" hide-details/>
                          </v-flex>
                          <v-flex md6 sm xs12 class="pa-1">
                            <v-text-field label="ชื่อบัญชี" hide-details/>
                          </v-flex>
                          <v-flex md6 sm xs12 class="pa-1">
                            <v-text-field label="เลขที่บัญชีธนาคาร" hide-details/>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <h3>จำนวนวันลา</h3>
                        <v-layout row wrap mx-3>
                          <v-flex md6 sm6 xs12 pa-1>
                            <v-text-field label="วันลากิจ" type="number" hide-details/>
                          </v-flex>
                          <v-flex md6 sm6 xs12 pa-1>
                            <v-text-field label="วันลาป่วย" type="number" hide-details/>
                          </v-flex>
                          <v-flex md6 sm6 xs12 pa-1>
                            <v-text-field label="วันลาพักร้อน" type="number" hide-details/>
                          </v-flex>
                          <v-flex md6 sm6 xs12 pa-1>
                            <v-text-field label="วันลาบวช" type="number" hide-details/>
                          </v-flex>
                          <v-flex md6 sm6 xs12 pa-1>
                            <v-text-field label="วันลาคลอด" type="number" hide-details/>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <!-- รายละเอียดทั่วไป -->
          <v-tab-item>
            <v-card>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex md6 sm6 xs12 class="pa-1">
                    <v-text-field name="กลุ่มพนักงาน" label="กลุ่มพนักงาน" hide-details/>
                  </v-flex>
                  <v-flex md6 sm6 xs12 class="pa-1">
                    <v-text-field name="ตำแหน่งอื่น" label="ตำแหน่งอื่น" hide-details/>
                  </v-flex>
                  <v-flex md6 sm6 xs12 class="pa-1">
                    <v-text-field name="ฝ่าย" label="ฝ่าย" hide-details/>
                  </v-flex>
                  <v-flex md6 sm6 xs12 class="pa-1">
                    <v-text-field name="ผู้อนุมัติ" label="ผู้อนุมัติ" hide-details/>
                  </v-flex>
                  <v-flex md6 sm6 xs12 class="pa-1">
                    <v-text-field
                      name="ผู้อนุมัติสิทธิ์และการลา_1"
                      label="ผู้อนุมัติสิทธิ์และการลา 2"
                      hide-details
                    />
                  </v-flex>
                  <v-flex md6 sm6 xs12 class="pa-1">
                    <v-text-field
                      name="ผู้อนุมัติสิทธิ์และการลา_2"
                      label="ผู้อนุมัติสิทธิ์และการลา 2"
                      hide-details
                    />
                  </v-flex>
                  <v-flex xs12>
                    <v-layout row wrap>
                      <v-flex md1 sm1 xs4>
                        <v-checkbox label="ฝึกงาน" value hide-details/>
                      </v-flex>
                      <v-flex md2 sm3 xs8>
                        <v-checkbox label="ไม่คำนวนวันทำงาน" value hide-details/>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12>
                    <h3>หักค่าใช้จ่าย</h3>
                    <v-layout row wrap class="ma-3">
                      <v-flex md6 sm6 xs12 class="pa-1">
                        <v-text-field name="อัตรา" label="อัตรา (%)" hide-details value="50"/>
                      </v-flex>
                      <v-flex md6 sm6 xs12 class="pa-1">
                        <v-text-field name="ฐาน" label="ฐาน" hide-details value="100000"/>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12>
                    <h3>ค่าลดหย่อน</h3>
                    <v-layout row wrap class="ma-3">
                      <v-flex md6 sm6 xs12 class="pa-1">
                        <v-text-field
                          name="ลดหย่อนผู้มีเงินได้"
                          label="ลดหย่อนผู้มีเงินได้"
                          hide-details
                          value="60000"
                        />
                      </v-flex>
                      <v-flex md6 sm6 xs12 class="pa-1">
                        <v-text-field
                          name="ลดหย่อนคู่สมรส"
                          label="ลดหย่อนคู่สมรส"
                          hide-details
                          value="0"
                        />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12>
                    <h3>ค่าลดหย่อนบุตร</h3>
                    <v-layout row wrap class="ma-3">
                      <v-flex md6 sm6 xs12 class="pa-1">
                        <v-text-field name="อัตรา" label="อัตรา" hide-details value="0"/>
                      </v-flex>
                      <v-flex md6 sm6 xs12 class="pa-1">
                        <v-text-field name="ฐาน" label="ฐาน" hide-details value="30000"/>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12>
                    <h3>ค่าลดหย่อนบิดามารดา</h3>
                    <v-layout row wrap class="ma-3">
                      <v-flex md6 sm6 xs12 class="pa-1">
                        <v-text-field name="อัตรา" label="อัตรา" hide-details value="0"/>
                      </v-flex>
                      <v-flex md6 sm6 xs12 class="pa-1">
                        <v-text-field name="ฐาน" label="ฐาน" hide-details value="30000"/>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12>
                    <h3>ค่าลดหย่อนผู้พิการหรือทุพพลภาพ</h3>
                    <v-layout row wrap class="ma-3">
                      <v-flex md6 sm6 xs12 class="pa-1">
                        <v-text-field name="อัตรา" label="อัตรา" hide-details value="0"/>
                      </v-flex>
                      <v-flex md6 sm6 xs12 class="pa-1">
                        <v-text-field name="ฐาน" label="ฐาน" hide-details value="30000"/>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12>
                    <h3>เบี้ยประกันชีวิต</h3>
                    <v-layout row wrap class="ma-3">
                      <v-flex md6 sm6 xs12 class="pa-1">
                        <v-text-field name="ฐาน" label="ฐาน" hide-details value="0"/>
                      </v-flex>
                      <v-flex md6 sm6 xs12 class="pa-1">
                        <v-text-field name="จำนวน" label="จำนวน" hide-details value="30000"/>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12>
                    <h3>เบี้ยประกันสุขภาพบิดามารดา</h3>
                    <v-layout row wrap class="ma-3">
                      <v-flex md6 sm6 xs12 class="pa-1">
                        <v-text-field name="ฐาน" label="ฐาน" hide-details value="0"/>
                      </v-flex>
                      <v-flex md6 sm6 xs12 class="pa-1">
                        <v-text-field name="จำนวน" label="จำนวน" hide-details value="30000"/>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12>
                    <h3>ดอกเบี้ยซื้อที่อยู่อาศัย</h3>
                    <v-layout row wrap class="ma-3">
                      <v-flex md6 sm6 xs12 class="pa-1">
                        <v-text-field name="ฐาน" label="ฐาน" hide-details value="0"/>
                      </v-flex>
                      <v-flex md6 sm6 xs12 class="pa-1">
                        <v-text-field name="จำนวน" label="จำนวน" hide-details value="30000"/>
                      </v-flex>
                      <v-flex md6 sm6 xs12 class="pa-1">
                        <v-text-field
                          name="ค่าซื้อกองทุนรวมหุ้นระยะยาว"
                          label="ค่าซื้อกองทุนรวมหุ้นระยะยาว (LTF)"
                          value="30000"
                        />
                      </v-flex>
                      <v-flex md6 sm6 xs12 class="pa-1">
                        <v-text-field
                          name="เบี้ยประกันชีวิตแบบบำนาญ"
                          label="เบี้ยประกันชีวิตแบบบำนาญ"
                          hide-details
                          value="30000"
                        />
                      </v-flex>
                      <v-flex xs12 class="pa-1">
                        <v-text-field
                          name="ค่าซื้อกองทุนRMF/กบข./กองทุนสํารองเลี้ยงชีพ/กองทุนสงเคราะห์ครูโรงเรียนเอกชน"
                          label="ค่าซื้อกองทุนRMF/กบข./กองทุนสํารองเลี้ยงชีพ/กองทุนสงเคราะห์ครูโรงเรียนเอกชน"
                          hide-details
                          value="0"
                        />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12>
                    <h3>ลดหย่อนอื่นๆ</h3>
                    <v-layout row wrap class="ma-3">
                      <v-flex xs12>
                        <v-btn color="success">
                          <v-icon :size="16">fa-plus</v-icon>
                          <span class="mx-1">เพิ่ม</span>
                        </v-btn>
                        <v-btn color="error">
                          <v-icon :size="16">fa-minus</v-icon>
                          <span class="mx-1">ลบ</span>
                        </v-btn>
                      </v-flex>
                      <v-flex md6 sm6 xs12 class="pa-1">
                        <v-text-field name="หัวข้อ" label="หัวข้อ" hide-details/>
                      </v-flex>
                      <v-flex md6 sm6 xs12 class="pa-1">
                        <v-text-field name="จำนวน" label="จำนวน" hide-details value="30000"/>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapActions } from "vuex";
export default {
  mounted() {
    this.setToolbar({
      pageTitle: "EmployeeCreate",
      patternTool: "2"
    });
  },
  methods: {
    ...mapActions("toolbar", ["setToolbar"])
  },
  data: () => {
    return {
      form_model: {
        status: ""
      },
      branch_model: [
        { รหัส: "001", ชื่อ: "สาขาทดสอบ-1" },
        { รหัส: "002", ชื่อ: "สาขาทดสอบ-2" },
        { รหัส: "003", ชื่อ: "สาขาทดสอบ-3" },
        { รหัส: "004", ชื่อ: "สาขาทดสอบ-4" }
      ],
      group_model: [
        { รหัส: "001", ชื่อ: "ฝ่าย-1" },
        { รหัส: "002", ชื่อ: "ฝ่าย-2" },
        { รหัส: "003", ชื่อ: "ฝ่าย-3" },
        { รหัส: "004", ชื่อ: "ฝ่าย-4" },
        { รหัส: "005", ชื่อ: "ฝ่าย-5" }
      ],
      rg_salary_type: null,
      salary_type_items: [
        { รหัส: "001", ชื่อ: "รายเดือน" },
        { รหัส: "002", ชื่อ: "รายวัน" },
        { รหัส: "003", ชื่อ: "รายชั่วโมง" }
      ],
      rg_working_status: null,
      working_status: [
        { รหัส: "001", ชื่อ: "ทำงาน" },
        { รหัส: "002", ชื่อ: "พักงาน" }
      ],
      วันหยุดประจำปี: [
        { รหัส: "000", ชื่อ: "ไม่เลือก" },
        { รหัส: "001", ชื่อ: "วันหยุดประจำปี 2018" }
      ],
      โปรไฟล์กะการทำงาน: [
        { รหัส: "000", ชื่อ: "ไม่เลือก" },
        { รหัส: "001", ชื่อ: "โปรไฟล์-1" },
        { รหัส: "002", ชื่อ: "โปรไฟล์-2" },
        { รหัส: "003", ชื่อ: "โปรไฟล์-3" },
        { รหัส: "004", ชื่อ: "โปรไฟล์-4" }
      ]
    };
  }
};
</script>